import React from "react";
import { Result, Button } from "antd";
import { useNavigate } from "react-router-dom";

const ErrorPage = () => {
  const navigate = useNavigate();

  return (
    <Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={
        <Button type="primary" onClick={() => navigate("/dashboard")}>
          Back to Dashboard
        </Button>
      }
    />
  );
};

export default ErrorPage;
